import { withStyles } from '@material-ui/core';

import SettingsPage from '@/components/Page';

import styles from './styles';

export default withStyles(styles)(SettingsPage);
